import {FileNameData} from '../FileNameData';

export class WfCompleteRequest {
    id: number;
    description: string;
}
